import React from 'react'

import { FormattedMessage } from 'react-intl'

import { CardDelta, CardLabel, CardRoot, CardValue, CardValueRow } from './StatCard.styled'

interface IProps {
  labelKey: string
  value: string | number | null | undefined
  delta?: number // percentage; positive = up, negative = down
}

// Unavailable metrics render as an em dash, never 0 (BRAND-9360).
// Whole abbreviated values drop the ".0" (52K, not 52.0K) per design spec (BRAND-9366).
const formatValue = (v: string | number | null | undefined): string => {
  if (v == null) return '—'
  if (typeof v === 'string') return v
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  if (v >= 1_000) return `${(v / 1_000).toFixed(1).replace(/\.0$/, '')}K`
  return String(v)
}

const StatCard: React.FC<IProps> = ({ labelKey, value, delta }) => {
  const direction = delta == null || delta === 0 ? 'flat' : delta > 0 ? 'up' : 'down'
  return (
    <CardRoot>
      <CardLabel>
        <FormattedMessage id={labelKey} />
      </CardLabel>
      <CardValueRow>
        <CardValue data-testid="stat-card-value">{formatValue(value)}</CardValue>
        {delta != null && (
          <CardDelta direction={direction}>
            {direction === 'up' ? '▲' : direction === 'down' ? '▼' : '—'}
            {Math.abs(delta).toFixed(1)}%
          </CardDelta>
        )}
      </CardValueRow>
    </CardRoot>
  )
}

export { StatCard, formatValue }
export default StatCard
